var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRoundRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.534 465.844C27.691 451.251 31.566 431.376 46.128 421.47C49.472 419.189 128.001 364.378 128.001 256.005C128.001 147.758 49.628 92.947 46.128 90.54C31.534 80.728 27.597 60.916 37.378 46.26C47.19 31.542 67.034 27.573 81.752 37.385C86.252 40.385 192 112.54 192 256.005S86.252 471.625 81.752 474.625C76.315 478.25 70.159 480 64.096 480C53.815 480 43.722 475.031 37.534 465.844Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRoundRight);
export default __webpack_public_path__ + "static/media/bracket-round-right.3d884ef70034a05c2b57a45515081552.svg";
export { ForwardRef as ReactComponent };